import { render, staticRenderFns } from "./EntityClassesEdit.vue?vue&type=template&id=e2fe6d62&scoped=true&"
import script from "./EntityClassesEdit.vue?vue&type=script&lang=js&"
export * from "./EntityClassesEdit.vue?vue&type=script&lang=js&"
import style0 from "./EntityClassesEdit.vue?vue&type=style&index=0&id=e2fe6d62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fe6d62",
  null
  
)

export default component.exports